// extracted by mini-css-extract-plugin
module.exports = {"Detail":"Detail_Detail__32b7B","List":"Detail_List__ZzFvZ","ListItem":"Detail_ListItem__L0akM"};